import { AchReversalAlertDto } from '@/models/suba/alerts/ach-reversal-alert-dto.model';
import { CashTransferRejectedAlertDto } from '@/models/suba/alerts/cash-transfer-rejected-alert-dto.model';
import { CustodianRejectAlertDto } from '@/models/suba/alerts/custodian-reject-alert-dto.model';
import { DepositAlertDto } from '@/models/suba/alerts/deposit-alert-dto.model';
import { DisbursementRequestAlertDto } from '@/models/suba/alerts/disbursement-request-alert-dto.model';
import { OrderCustodianUnitSellOffsetAlertDto } from '@/models/suba/alerts/order-custodian-unit-sell-offset-alert-dto.model';
import { UnexpectedStatusUpdateAlertDto } from '@/models/suba/alerts/unexpected-status-update-alert-dto.model';
import { useAlertContext } from '@/routes/suba/common/contexts/AlertContext';
import { AlertSubType } from '@vestwell-sub-accounting/models/common/AlertSubType';

import { FC } from 'react';

import { DefaultAlertDetailFields } from './common/DefaultAlertDetailFields.component';
import { DisbursementAlertDetailFields } from './disbursement/disbursement-request/DisbursementAlertDetailFields.component';
import { ACHReversalAlertDetailFields } from './money-in/ach-reversal/ACHReversalAlertDetailFields.component';
import { CashTransferRejectedAlertDetailFields } from './money-in/cash-transfer-rejected/CashTransferRejectedAlertDetailFields.component';
import { MoneyInAlertDetailFields } from './money-in/MoneyInAlertDetailFields.component';
import { RolloversAlertDetailFields } from './rollovers/new-rollover-deposit/RolloversAlertDetailFields.component';
import { CustodianDestinationRejectAlertDetailFields } from './trading/common/CustodianDestinationRejectAlertDetailFields.component';
import { OrderCustodianUnitSellOffsetAlertDetailFields } from './trading/order-custodian-unit-sell-offset/OrderCustodianUnitSellOffsetAlertDetailFields.component';
import { UnexpectedStatusUpdateDetailFields } from './trading/unexpected-status-update/UnexpectedStatusUpdateDetailFields.component';

export const AlertDetails: FC = () => {
  const alert = useAlertContext();

  if (!alert) return null;

  switch (alert.alertSubType) {
    case AlertSubType.NewConversionDeposit:
    case AlertSubType.UnclassifiedDeposit:
      return <MoneyInAlertDetailFields alert={alert as DepositAlertDto} />;
    case AlertSubType.OrderCustodianUnitSellOffset:
      return (
        <OrderCustodianUnitSellOffsetAlertDetailFields
          alert={alert as OrderCustodianUnitSellOffsetAlertDto}
        />
      );
    case AlertSubType.ACHReversal:
      return (
        <ACHReversalAlertDetailFields
          alert={alert as AchReversalAlertDto | DepositAlertDto}
        />
      );
    case AlertSubType.UnexpectedStatusUpdate:
      return (
        <UnexpectedStatusUpdateDetailFields
          alert={alert as UnexpectedStatusUpdateAlertDto}
        />
      );
    case AlertSubType.NewRolloverDeposit:
      return <RolloversAlertDetailFields alert={alert as DepositAlertDto} />;
    case AlertSubType.CashTransferRejected:
      return (
        <CashTransferRejectedAlertDetailFields
          alert={alert as CashTransferRejectedAlertDto}
        />
      );
    case AlertSubType.CustodianReject:
    case AlertSubType.DestinationReject:
      return (
        <CustodianDestinationRejectAlertDetailFields
          alert={alert as CustodianRejectAlertDto}
        />
      );
    case AlertSubType.DisbursementRequest:
      return (
        <DisbursementAlertDetailFields
          alert={alert as DisbursementRequestAlertDto}
        />
      );
    default:
      return <DefaultAlertDetailFields alert={alert} />;
  }
};
